import { showBanner } from './../template/template.js'
import './style.min.css'

const table = document.querySelector('.table')
const amountRaised = document.querySelector('.amount.raised')
const amountSpent = document.querySelector('.amount.spent')
const amountNet = document.querySelector('.amount.net')
const amountDonated = document.querySelector('.amount.donated')

const GoogleSheetsAPIURL =
    'https://sheets.googleapis.com/v4/spreadsheets/1P1PiaQkHS39p3nOG2AVhZMoU2FQnpQPVRBCG9ozcYC4/values/Sorted!A:C?key=AIzaSyCAbZoRrxcMfvj50hB_XZ1qfDclIhx3CsE&majorDimension=ROWS'

// Send GET request
function httpGetAsync(url, callback) {
    var xmlHttp = new XMLHttpRequest()
    xmlHttp.onreadystatechange = function () {
        // Check if request is done
        if (xmlHttp.readyState == 4) {
            // Check if request is successful
            if (xmlHttp.status == 200) {
                callback(JSON.parse(xmlHttp.response))
            }
            // Wait until the request is done before checking for error
            else {
                let div = document.createElement('div')
                div.innerHTML =
                    document.documentElement.lang == 'fr'
                        ? 'Une erreur est survenue :( <br /><br />Veuillez rafraîchir cette page ou contacter <a href="mailto:it@teamcoda.org">it@teamcoda.org</a>'
                        : 'An unexpected error occurred :( <br /><br />Please refresh this page or contact <a href="mailto:it@teamcoda.org?subject=BUG%20REPORT&body=The%20contents%20of%20the%20transparency%20page%20could%20not%20be%20loaded">it@teamcoda.org</a>'
                div.classList.add('entry')
                div.classList.add('title')
                div.classList.add('entire-row')
                showBanner("We couldn't fetch the data :(", 'Une erreur est survenue :(', 0)
                table.appendChild(div)
            }
        }
    }
    xmlHttp.open('GET', url, true)
    xmlHttp.send(null)
}

// Send GET request to Google Sheets API
httpGetAsync(GoogleSheetsAPIURL, (response) => {
    response.values.forEach((array, index) => {
        // Insert titles row (index 0)
        if (index === 0) {
            insertRow(document.documentElement.lang == 'fr' ? ['Date', 'Nom', 'Montant'] : array, true)
            return
        }
        // Insert totals row (index 1, 2, and 3)
        if (index <= 4) {
            insertRow(array, false, index)
            return
        }
        insertRow(array)
    })
})

// Create HTML elements
function insertRow(array, isTitle = false, totalIndex = null) {
    // Check if date is valid
    if (parseInt(array[0]) < 2000) {
        array[0] = 'N/A'
    }

    array.forEach((string) => {
        let div = document.createElement('div')
        div.innerText = string
        div.classList.add('entry')
        if (isTitle) {
            div.classList.add('title')
            div.classList.add('line')
        } else if (totalIndex === 1) {
            amountRaised.innerText = string
            return
        } else if (totalIndex === 2) {
            amountSpent.innerText = string
            return
        } else if (totalIndex === 3) {
            amountNet.innerText = string
            return
        } else if (totalIndex === 4) {
            amountDonated.innerText = string
            return
        }
        table.appendChild(div)
    })
}
